import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import App from "./App";
import { ChakraProvider, extendTheme } from "@chakra-ui/react";
import { BrowserRouter } from "react-router-dom";
import AuthContextProvider from "./context/authContext";
const WEB_PUSH_PUBLIC_KEY = "BKvNbHgS5v8Zte52gho8pFEOgS0gG65hl6rCYaJhEd7ewl27DNzRFNn-M69H8Gw9dyVKK_bu9Q9TAe16Onl0nkA";


export const transition = { enter: { duration: 0.5 }, exit: { duration: 0.1 } };

const theme = extendTheme({
  colors: {
    //AAHERA Colors
    // primary: "rgb(7,47,100)",
    primary: "rgb(7,47,100)",
    primaryDark: "rgb(3, 23, 48)",
    // primary: "#1D8C23",
    // primaryDark: "#1D8C23",
    primaryLight: "rgba(7, 47, 103, 0.8)",
    secondary: "#FC7067",
    bgColor: "#EFE2FF",
    bgColorLight: "#F9F9F9",
    lightPink: "#FEE8E7",
  },

  styles: {
    global: {
      body: {
        fontFamily: "Raleway, sans-serif",
        fontSize: "14px",
        // color: "#1D8C23",
        color: "rgb(7,47,100)",
        fontWeight: 500,
      },
    },
  },
});

// Register service worker
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js')
      .then(registration => {
        console.log('ServiceWorker registration successful');
        
        // Request notification permission
        Notification.requestPermission().then(permission => {
          if (permission === 'granted') {
            console.log('Notification permission granted');
            // Subscribe to push notifications
            registration.pushManager.subscribe({
              userVisibleOnly: true,
              applicationServerKey: WEB_PUSH_PUBLIC_KEY // Replace with your VAPID public key
            })
            .then(subscription => {
              console.log('Push notification subscription:', subscription);
              // Send subscription to your backend
              // You can store this in your user's profile or send it to your server
            })
            .catch(error => {
              console.error('Error subscribing to push notifications:', error);
            });
          }
        });
      })
      .catch(err => {
        console.log('ServiceWorker registration failed: ', err);
      });
  });
}

ReactDOM.render(
  <React.StrictMode>
    <BrowserRouter>
      <AuthContextProvider>
        <ChakraProvider theme={theme}>
          <App />
        </ChakraProvider>
      </AuthContextProvider>
    </BrowserRouter>
  </React.StrictMode>,
  document.getElementById("root")
);
// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://cra.link/PWA
// ServiceWorkerRegistration.register();
